<template>
  <HmsContainer />
</template>

<script lang="ts">
import Vue from "vue";
import HmsContainer from "@/components/projects/project/hms/container/HmsContainer.vue";

export default Vue.extend({
  components: {
    HmsContainer,
  },
});
</script>
